// eslint-disable-next-line import/no-extraneous-dependencies
import axios from 'axios';
// import http from 'http';
// import https from 'https';

import {
  apiConfig,
  baseConfig,
} from './casaApisConfig';

import {
  handleApiResponse,
  handleApiError,
} from './helpers';

import {
  isValidVar,
} from '../checkVarType';

/**
  * @desc Library to perform httpRequests (based on axios)
  *
  * @param {string} env current enviroment (local | dev | stg | prod)
  * @param {string} service api service you want to reach (esapi | account...)
  * @param {string} site depending on the configurations it could work for any site.
  *
  * @returns {DOMElement} API response in JSON format
*/
class CasaHttpRequest {
  constructor(env, service, site = 'it_casa') {
    if (
      !isValidVar(env)
      && !isValidVar(service)
    ) {
      this.serviceConfig = null;
      this.defaultConfig = baseConfig;
    } else {
      this.serviceConfig = apiConfig[site][service];
      this.defaultConfig = { ...baseConfig, baseURL: this.serviceConfig.baseURL[env] };
    }
    this.abort = {
      source: null,
      token: null,
    };
  }

  resetCancelRequest() {
    this.abort.source = null;
    this.abort.token = null;
  }

  uniqueCancelRequest() {
    this.resetCancelRequest();
    const cancelTokenSource = axios.CancelToken.source();
    this.abort.source = cancelTokenSource;
    this.abort.token = cancelTokenSource.token;
  }

  abortRequest(msg = null) {
    if (isValidVar(this.abort.source)) {
      this.abort.source.cancel(msg || 'Request aborted');
    }
  }

  get(
    url,
    params = {},
    // keepAlive,
    validation = {},
    timeout = 0, // default -> no timeout
  ) {
    this.uniqueCancelRequest();
    const defaultParams = { ...params };
    const { headers } = params;
    delete defaultParams.headers;
    const apiResponse = axios({
      url,
      method: 'get',
      baseURL: this.defaultConfig.baseURL,
      params: defaultParams,
      headers,
      timeout,
      // httpAgent: isValidVar(keepAlive) && keepAlive && new http.Agent({ keepAlive }),
      // httpsAgent: isValidVar(keepAlive) && keepAlive && new https.Agent({ keepAlive }),
      cancelToken: this.abort.token,
    }).then((resp) => handleApiResponse(
      resp, validation, this.serviceConfig, this.resetCancelRequest,
    )).catch((err) => handleApiError(err, axios.isCancel(err)));
    return apiResponse;
  }

  post(
    url,
    payload = {},
    options = {},
    validation = {},
  ) {
    this.uniqueCancelRequest();
    const mergeOptions = (obj1, obj2) => {
      if (obj2.headers) {
        const headers = {
          ...obj1.headers,
          ...obj2.headers,
        };
        return {
          ...obj1,
          ...obj2,
          headers,
        };
      }
      return { ...obj1, ...obj2 };
    };
    const mergedOptions = mergeOptions(this.defaultConfig, options);

    const apiResponse = axios({
      url,
      method: 'post',
      data: payload,
      ...mergedOptions,
      cancelToken: this.abort.token,
    }).then((resp) => handleApiResponse(resp, validation, this.serviceConfig))
      .catch((err) => handleApiError(err, axios.isCancel(err)));
    return apiResponse;
  }

  put(
    url,
    payload = {},
    options = {},
    validation = {},
  ) {
    const apiResponse = axios({
      url,
      method: 'put',
      data: payload,
      ...{ ...this.defaultConfig, ...options },
      cancelToken: this.abort.token,
    }).then((resp) => handleApiResponse(resp, validation, this.serviceConfig))
      .catch((err) => handleApiError(err, axios.isCancel(err)));
    return apiResponse;
  }

  delete(
    url,
    payload = {},
    options = {},
    validation = {},
  ) {
    const apiResponse = axios({
      url,
      method: 'delete',
      data: payload,
      ...{ ...this.defaultConfig, ...options },

    }).then((resp) => handleApiResponse(resp, validation, this.serviceConfig))
      .catch((err) => handleApiError(err, axios.isCancel(err)));
    return apiResponse;
  }
}

export default CasaHttpRequest;
